import { CategoryId } from '$/epg/categories'
import { epgChannelsModel } from '$/epg/channels'
import { attach, createEvent, createStore, sample } from 'effector'
import { INITIAL_COUNT, INITIAL_PAGE } from './index.h'

// load channels by category id
export const load = createEvent<{ categoryId: number }>()

// load initial channels list effect
export const loadInitialChannelsFx = attach({
  mapParams: ({ categoryId }: { categoryId: number }) => ({
    'byCategoryId': categoryId,
    'categoryId': categoryId === CategoryId.Favorite ? undefined : categoryId,
    'only-favorites': categoryId === CategoryId.Favorite ? true : undefined,
    'page': INITIAL_PAGE,
    'count': INITIAL_COUNT,
  }),
  effect: epgChannelsModel.loadPageFx,
})

// currently loading categories
export const $pending = createStore<[Map<number, boolean>]>([new Map()])

// add category to pending
sample({
  clock: loadInitialChannelsFx,
  source: $pending,
  fn: (pending, { categoryId }) => {
    const [map] = pending
    map.set(categoryId, true)
    return [map] as const
  },
  target: $pending,
})

// remove category from pending upon request completion
sample({
  clock: loadInitialChannelsFx.finally,
  source: $pending,
  fn: (pending, { params: { categoryId } }) => {
    const [map] = pending
    map.delete(categoryId)
    return [map] as const
  },
  target: $pending,
})

// load channels on category change
sample({
  clock: load,
  source: {
    byCategory: epgChannelsModel.$byCategory,
    pending: $pending,
  },
  filter: ({ byCategory: [channels, meta], pending }, { categoryId }) => {
    if (pending[0].get(categoryId)) return false // already loading channels for this category

    const loadedCount = channels.get(categoryId)?.length ?? 0
    const isLast = Boolean(meta.get(categoryId)?.isLast)
    return loadedCount < INITIAL_COUNT && !isLast
  },
  fn: (_, { categoryId }) => ({ categoryId }),
  target: loadInitialChannelsFx,
})
